import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { render } from 'react-dom';
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Provider } from 'react-redux';

import reducer from './reducers';
import Account from './pages/Account';
import Billing from './pages/Billing';
import Profile from './pages/Profile';
import AdsProfile from './pages/AdsProfile';
import Declined from './pages/Declined';
import Ads from './pages/Ads';
import EmailConfirmation from './pages/EmailConfirmation';
// import AdsProfile from './pages/AdsProfile';
// import AdsBilling from './pages/AdsBilling';

import './index.scss';

const store = createStore(reducer, applyMiddleware(thunkMiddleware));

render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/update_email" component={EmailConfirmation} />
        <Route path="/account_details" component={Profile} />
        <Route path="/ads/account_details" component={AdsProfile} />
        <Route path="/billing" component={Billing} />
        <Route path="/ads/billing" component={Billing} />
        {/* <Route path="/ads/billing" component={AdsBilling} /> */}
        <Route path="/declined" component={Declined} />
        <Route path="/ads" component={Ads} />
        <Route path="/" component={Account} />
        <Redirect to="/" />
      </Switch>
    </Router>
  </Provider>
  , document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js